const timers = {
  "loadingStateDuration": 500,
  "errorStateDuration": 2000,
  "asyncOffsetDuration": 500,
  "logoutAfterAutoOpenDuration": 2000,
  "responseBannerDuration": 2000
}

export default timers
